import styled from "styled-components"
import { device } from "breakpoints"
import AvenueImg from "components/AvenueImg"
import { MainColumn } from "components/MainColumn"

export const BackgroundImgWrapper = styled.div`
  padding-top: 45.14%;
  position: relative;

  :before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 69%,
      rgba(0, 0, 0, 0.45) 92%
    );
    z-index: 2;
  }

  :after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0;
    transition: 370ms;
  }
`

export const FullwidthCTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 1660px;
  margin: ${props => `${props.theme.componentMargin.mobile}px auto 0 auto`};
  @media ${device.desktop} {
    margin: ${props => `${props.theme.componentMargin.desktop}px auto 0 auto`};
  }

  @media ${device.large} {
    margin: ${props => `${props.theme.componentMargin.large}px auto 0 auto`};
  }

  :hover {
    ${BackgroundImgWrapper} {
      :after {
        opacity: 0.2;
      }
    }

    svg {
      transform: translateX(10px);
    }
  }
`
export const BackgroundImg = styled(AvenueImg)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const InnerWrapper = styled(MainColumn)`
  position: absolute;
  left: 50%;
  height: 100%;
  transform: translateX(-50%);
  bottom: 0px;
  padding-bottom: 30px;
  flex-direction: row;
  align-items: flex-end;
  z-index: 3;
  @media ${device.desktop} {
    padding-bottom: 55px;
  }
  @media ${device.large} {
    padding-bottom: 80px;
  }
  h5 {
    font-size: 10px;
    color: white;
    opacity: 0.5;
    letter-spacing: 4.29px;
    font-weight: bold;
    margin-bottom: 10px;

    @media ${device.desktop} {
      font-size: 12px;
      letter-spacing: 5.14px;
    }
  }

  h2 {
    font-size: 28px;
    color: white;

    @media ${device.desktop} {
      font-size: 40px;
    }

    @media ${device.large} {
      font-size: 48px;
    }
  }
`
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    width: 50%;
    padding-right: 10px;
  }

  @media ${device.desktop} {
    padding-right: 20px;
  }
`

export const TextWrapper = styled.div`
  display: none;
  align-items: center;

  @media ${device.tablet} {
    display: flex;
    width: 50%;
    padding-left: 10px;
    margin-bottom: -10px;
  }

  @media ${device.desktop} {
    padding-left: 20px;
    margin-bottom: -15px;
  }
  p {
    color: #4c4d58;
    font-size: 16px;

    @media ${device.tablet} {
      color: white;
    }

    @media ${device.desktop} {
      font-size: 18px;
    }
    @media ${device.large} {
      font-size: 20px;
    }
  }

  a {
    flex-shrink: 0;

    :before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100vw;
      max-width: 1660px;

      height: 100%;
      z-index: 5;
      cursor: pointer;
      background: none;
    }
  }

  svg {
    width: 42px;
    height: 42px;
    margin-left: 16px;
    transform: translateX(0);
    transition: 370ms;
    g {
      circle {
        stroke: #009639;
      }
      path {
        fill: #009639;
      }

      @media ${device.tablet} {
        circle {
          stroke: white;
        }
        path {
          fill: white;
        }
      }
    }

    @media ${device.tablet} {
      margin-left: 20px;
    }
    @media ${device.desktop} {
      margin-left: 30px;
      width: 48px;
      height: 48px;
    }
  }
`
export const OuterTextWrapper = styled(TextWrapper)`
  margin-bottom: 0;
  display: flex;
  margin-top: 20px;

  @media ${device.tablet} {
    display: none;
  }
`
